import PropTypes from "prop-types"
import React, { useState, useEffect, useRef } from "react"
// //Import Scrollbar
import SimpleBar from "simplebar-react"
import { getUnApprovalCounts } from "../../store/user/actions"
import { retrieveValues } from "../../helpers/storagewrapper.js"
// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
//i18n
import { withTranslation } from "react-i18next"
//redux
import { useDispatch } from "react-redux"
import { isEmpty } from "lodash"

const SidebarContent = props => {
  const dispatch = useDispatch()
  const ref = useRef()
  const [count, setCount] = useState(0)
  const [isAccess, setAccess] = useState(true)

  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  const checkAccess = module => {
    let access = false
    if (retrieveValues("authUser")) {
      const obj = JSON.parse(retrieveValues("authUser"))
      const controls = obj?.data?.controls || {}
      if (obj?.data?.type == "SUPER_ADMIN") {
        access = true
      } else if (!isEmpty(controls)) {
        Object.keys(controls).map((type, index) => {
          let findIndex = controls[type].findIndex(
            el => el.key == module && el.selected == true
          )
          if (findIndex > -1 && !access) {
            access = true
          }
        })
      }
    }
    return access
  }

  useEffect(() => {
    dispatch(getUnApprovalCounts())
  }, [dispatch])

  useEffect(() => {
    if (props.unApprovalCount) {
      const item = props.unApprovalCount
      setCount(
        (item?.unApproveUsersCount || 0) +
          (item?.unApproveChangesCount || 0) +
          (item?.unApproveGuestCount || 0)
      )
    }
  }, [props.unApprovalCount])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">
              {props.t("Carpark Management System")}{" "}
            </li>
            {checkAccess("dashboard") && (
              <li>
                <Link to="/#" className="">
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Dashboards")}</span>
                </Link>
              </li>
            )}
            {checkAccess("tickets") && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="mdi mdi-ticket-confirmation-outline"></i>
                  <span>{props.t("Tickets")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/audit-tickets">{props.t("Audit Trails")}</Link>
                  </li>
                  <li>
                    <Link to="/carpark-tickets">{props.t("Session Tickets")}</Link>
                  </li>
                  <li>
                    <Link to="/occupancy-rate">{props.t("Occupancy Rate")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {checkAccess("manage_admins") && (
              <li>
                <Link to="/manage-admins" className="">
                  {/* <i className="bx bx-chat"></i> */}
                  <i className="mdi mdi-badge-account-outline"></i>
                  <span>{props.t("Manage Admins")}</span>
                </Link>
              </li>
            )}

            {checkAccess("system_settings") && (
              <li>
                <Link to="/system-settings" className="">
                  {/* <i className="bx bx-chat"></i> */}
                  <i className="mdi mdi-application-cog"></i>
                  <span>{props.t("System Settings")}</span>
                </Link>
              </li>
            )}

            <li className="menu-title">{props.t("App user management")}</li>

            {checkAccess("manage_approval") && (
              <li>
                <Link to="/#" className="">
                  <i className="mdi mdi-account-multiple-check-outline"></i>
                  <span className="badge rounded-pill bg-info float-end">
                    {count}
                  </span>
                  <span>{props.t("Manage Approvals")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/user-approvals">{props.t("User Approval")}</Link>
                  </li>
                  <li>
                    <Link to="/guest-approvals">
                      {props.t("Guest Approval")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/details-change-approvals">
                      {props.t("Change Approval")}
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {checkAccess("manage_roles") && (
              <li>
                <Link to="/roles" className=" ">
                  <i className="mdi mdi-account-key-outline"></i>
                  <span>{props.t("Manage Roles")}</span>
                </Link>
              </li>
            )}

            {checkAccess("manage_users") && (
              <li>
                <Link to="/users" className="">
                  {/* <i className="bx bx-chat"></i> */}
                  <i className="mdi mdi-badge-account-horizontal-outline"></i>
                  <span>{props.t("Manage Users")}</span>
                </Link>
              </li>
            )}

            {checkAccess("manage_guest") && (
              <li>
                <Link to="/guests" className="">
                  <i className="mdi mdi-account-group-outline"></i>
                  <span>{props.t("Manage Guests")}</span>
                </Link>
              </li>
            )}

            {checkAccess("manage_bills") && (
              <li>
                <Link to="/bills" className="">
                  <i className="mdi mdi-script-outline"></i>
                  <span>{props.t("Manage Bills")}</span>
                </Link>
              </li>
            )}

            {checkAccess("manage_blacklists") && (
              <li>
                <Link to="/blacklists" className="">
                  <i className="mdi mdi-script-outline"></i>
                  <span>{props.t("Manage Blacklist")}</span>
                </Link>
              </li>
            )}

            <li className="menu-title">{props.t("Carparks management")}</li>
            {checkAccess("manage_season_passes") && (
              <li>
                <Link to="/season-passes" className="">
                  <i className="mdi mdi-puzzle-outline"></i>
                  <span>{props.t("Manage Season Passes")}</span>
                </Link>
              </li>
            )}

            {checkAccess("manage_carparks") && (
              <li>
                <Link to="/carparks" className="">
                  <i className="mdi mdi-car-brake-parking"></i>
                  <span>{props.t("Manage Carparks")}</span>
                </Link>
              </li>
            )}

            {/* {checkAccess("manage_special_dates") && (
              <li>
                <Link to="/special-dates" className="">
                  <i className="mdi mdi-calendar-clock"></i>
                  <span>{props.t("Manage Special Dates")}</span>
                </Link>
              </li>
            )} */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  unApprovalCount: PropTypes.object,
}

const mapStatetoProps = state => {
  const { unApprovalCount } = state.users
  return { unApprovalCount }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(SidebarContent))
)
